// extracted by mini-css-extract-plugin
export var buttons = "_35-0";
export var buttonsActive = "_35-h";
export var cancelConfirm = "_35-1";
export var closeButton = "_35-2";
export var column = "_35-3";
export var container = "_35-4";
export var detailHeader = "_35-6";
export var detailTitle = "_35-7";
export var detailsContent = "_35-5";
export var header = "_35-8";
export var headerWithClose = "_35-9";
export var icon = "_35-a";
export var infoIcon = "_35-c";
export var informationContainer = "_35-b";
export var sideDrawer = "_35-d";
export var sideDrawerOpen = "_35-e";
export var stickyFooter = "_35-f";
export var typeOption = "_35-g";